module.exports = __webpack_public_path__ + "img/blog-7-5.49879e15.webp";